import React from 'react';
import styles from './connection-status.module.scss';
import { Lifecycle } from '@bit/amit.capsule-dev.remote-capsule';

const statusToText = new Map<Lifecycle, string>([
	[Lifecycle.Connected, 'Connected'],
	[Lifecycle.Reconnecting, 'Connecting...'],
	[Lifecycle.Connecting, 'Connecting...'],
	[Lifecycle.Disconnected, 'Disconnected'],
	[Lifecycle.Idle, 'Idle'],
]);

export type ConnectionStatusProps = {
	status?: Lifecycle;
};

export default function ConnectionIndicator({ status }: ConnectionStatusProps) {
	if (!status || !statusToText.has(status)) return null;
	return (
		<div id={styles.connectionStatus} className={styles[status.toString()]}>
			{statusToText.get(status)}
		</div>
	);
}
